export let svgOutnlineStyle = {
  "fillColor": "#EFEFEF",
  "color": "#A0A",
  "weight": 3,
  "opacity": 0.8,
  "fillOpacity": 0.3
};
